import { Component } from '@angular/core';

/**
 * Nota di retention mostrata nelle modali di dettaglio lead (Contacts management e Quotes
 * management) quando il numero è già stato sbloccato: da quel momento il partner ha in mano un
 * contatto che sopravvive alla richiesta, quindi va avvisato che i dettagli spariranno.
 * I pannelli sono renderizzati solo in inglese, quindi il testo resta alla sorgente in inglese.
 */
@Component({
    selector: 'app-retention-disclaimer',
    standalone: false,
    template: `
    <div class="retention-disclaimer">
      <i class="ti ti-info-circle"></i>
      <span>{{ 'Request details will no longer be visible 30 days after the submission date or if cancelled earlier by the user.' | translate }}</span>
    </div>
  `,
    styles: [`
    .retention-disclaimer {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      margin-top: 1rem;
      color: #6c757d;
      font-size: 12px;
      line-height: 1.4;
    }

    .retention-disclaimer i {
      font-size: 14px;
      line-height: 1.4;
      flex-shrink: 0;
    }
  `]
})
export class RetentionDisclaimerComponent { }
